import { render, staticRenderFns } from "./Queimadas.vue?vue&type=template&id=2340c3cc&lang=pug"
import script from "./Queimadas.vue?vue&type=script&lang=js"
export * from "./Queimadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports